@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.schoolAdminProfileContainer {
  background-color: variables.$white;
  padding: variables.$std-padding-sm;
  margin-top: variables.$std-margin-sm;
  color: variables.$black;
}
